export interface BaseState<T> {
    loading: boolean;
    loaded: boolean | null;
    data: T | null;
}

export class StateManager {
    static initial<T>(loading = false): BaseState<T> {
        return {
            loading,
            loaded: null,
            data: null,
        };
    }

    static setLoading<T>(state: BaseState<T>): BaseState<T> {
        return {
            ...state,
            loading: true,
        };
    }

    static setLoadingInitOnly<T>(state: BaseState<T>): BaseState<T> {
        return {
            ...state,
            loading: state?.data === null,
        };
    }

    static setLoaded<T>(state: BaseState<T>, data: T): BaseState<T> {
        return {
            ...state,
            loading: false,
            loaded: true,
            data,
        };
    }
    static setError<T>(state: BaseState<T>): BaseState<T> {
        return {
            ...state,
            loading: false,
            loaded: false,
            data: null,
        };
    }
}
